const r = ":host{display:block;text-align:center;margin-bottom:3.5rem}.sl-section-header__eyebrow{font-size:var(--sl-font-size-xs);font-weight:var(--sl-font-weight-semibold);letter-spacing:0.1em;text-transform:uppercase;color:hsl(var(--sl-hsl-primary));margin-bottom:0.75rem}.sl-section-header__title{font-size:clamp(1.5rem,3vw,2rem);font-weight:var(--sl-font-weight-semibold);line-height:1.2;letter-spacing:-0.01em;margin-bottom:0.875rem}.sl-section-header__desc{color:hsl(var(--sl-hsl-muted-foreground));max-width:48ch;margin:0 auto;line-height:1.7}";
class o extends HTMLElement {
  static get observedAttributes() {
    return ["eyebrow"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  attributeChangedCallback(e, t, s) {
    t !== s && this._render();
  }
  get eyebrow() {
    return this.getAttribute("eyebrow") || "";
  }
  set eyebrow(e) {
    this.setAttribute("eyebrow", e);
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${r}</style>
      <div class="sl-section-header">
        <div class="sl-section-header__eyebrow">${this.eyebrow}</div>
        <h2 class="sl-section-header__title"><slot name="title"></slot></h2>
        <p class="sl-section-header__desc"><slot></slot></p>
      </div>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-section-header") && customElements.define("sl-section-header", o);
export {
  o as SlSectionHeaderElement
};
//# sourceMappingURL=sl-section-header.js.map
